import { Modal, ModalBody, ModalContent, ModalOverlay, useToast, } from '@chakra-ui/react';
import React from 'react';
import { Formik } from 'formik';
import useGenericMutationUseCase from '../../../../hooks/usecases/generic/useGenericMutationUseCase';
import { getGetInspectionDetailQueryKey, useUpdateFinding, } from '../../../../services/api/generated/client';
import { localise, templateReplace } from '../../../../services/lang/lang';
import StandardModalHeader from '../../Modal/StandardModalHeader';
import EditFindingFormWrapper from './EditFindingFormWrapper';
import SuspenseWrapper from '../../SuspenseWrapper/SuspenseWrapper';
import { queryClient } from '../../../../services/api/query/queryClient';
import { useInspectionDetailContext } from '../../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import EditFindingFormShareWrapper from './Share/EditFindingFormShareWrapper';
import RenderIfElse from '../../RenderIf/RenderIfElse';
const EditFindingModal = (props) => {
    const { isShare } = useInspectionDetailContext();
    const updateFinding = useGenericMutationUseCase(useUpdateFinding);
    const toast = useToast();
    const initialValues = {
        action_type_id: props.finding.action_type?.id,
        hazards: props.finding.hazards,
        elements: props.finding.elements,
    };
    const { inspection } = useInspectionDetailContext();
    const onSubmit = (values, helpers) => {
        const hasActionTypeIdChanged = values.action_type_id !== initialValues.action_type_id;
        updateFinding.execute({
            id: props.finding.id,
            data: {
                action_type_id: values.action_type_id,
                hazards: values.hazards.map((hazard) => hazard.id),
                elements: values.elements.map((element) => element.id),
            },
        }, helpers, {
            onSuccess: () => {
                toast({
                    title: localise('FINDING_UPDATED'),
                    status: 'success',
                    isClosable: true,
                });
                if (hasActionTypeIdChanged) {
                    queryClient.invalidateQueries({
                        queryKey: getGetInspectionDetailQueryKey(inspection.id),
                    });
                }
                props.onSuccess();
            },
        });
    };
    return (React.createElement(Modal, { variant: "primary", isOpen: true, onClose: props.onClose },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, null,
            React.createElement(StandardModalHeader, { title: templateReplace(props.canEdit
                    ? localise('EDIT_FINDING_DETAILS')
                    : localise('FINDING_DETAILS'), {
                    finding: props.finding.reference,
                }) }),
            React.createElement(ModalBody, null,
                React.createElement(SuspenseWrapper, null,
                    React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
                        React.createElement(RenderIfElse, { condition: !!isShare, then: React.createElement(EditFindingFormShareWrapper, { onClose: props.onClose }), else: React.createElement(EditFindingFormWrapper, { canEdit: props.canEdit, onClose: props.onClose }) })))))));
};
export default EditFindingModal;
